export const GET_BUSINESS_LINE = 'COMMON/get_business_line';

export const OTHER_FEES_FEETYPE_OPTIONS = [
  { label: 'ALL', value: '' },
  { label: 'COMMON FEE', value: 'COMMON_FEE' },
  { label: 'SPECIFIC FEE', value: 'SPECIFIC_FEE' },
];

export const OTHER_FEES_TYPE_OPTIONS = [
  { label: 'ALL', value: '' },
  { label: 'BARANGAY BUSINESS CLEARANCE', value: 'BARANGAY CLEARANCE' },
  { label: 'BASIC', value: 'BASIC' },
  { label: 'BOOLEAN', value: 'BOOLEAN' },
  { label: 'FIRE SAFETY', value: 'FIRE SAFETY' },
  { label: 'OPTION', value: 'OPTION' },
  { label: 'QUANTITY', value: 'QUANTITY' },
  { label: 'RANGE', value: 'RANGE' },
  { label: 'VETERINARY', value: 'VETERINARY' },
  { label: 'ZONING', value: 'ZONING' },
  { label: 'ZONING PROCESSING', value: 'ZONING PROCESSING' },
];

export const MAX_LIMIT = '9999999999999.99';

export const GET_REPORT_ACCESS = 'COMMON/get_report_access';